import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "offline-all",
  "use": "offline-all-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"offline-all\"><title>全部设备离线</title><path d=\"M6 0a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm3.76 6a.42.42 0 0 1-.43.42H2.67A.42.42 0 0 1 2.24 6a.42.42 0 0 1 .43-.42h6.66a.42.42 0 0 1 .43.42z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/offline-all.svg
// module id = MIQc
// module chunks = 6